// extracted by mini-css-extract-plugin
export var growableInput = "_3l-0";
export var tagContainer = "_3l-2";
export var textInput = "_3l-1";